import moment from 'moment'

const BILLING_DATE_ONLY = 'MM/DD/YYYY'
const BILLING_DATE_TIME = 'MM/DD/YYYY, hh:mm A'

/** Fixed US-style billing dates (not browser locale). Uses local moment parsing. */
export const formatBillingDateOnly = (value?: string | null): string => {
  if (!value) return ''
  const parsed = moment(value)
  if (!parsed.isValid()) return ''
  return parsed.format(BILLING_DATE_ONLY)
}

/** Fixed US-style billing date + time. Uses local moment parsing. */
export const formatBillingDateTime = (value?: string | null): string => {
  if (!value) return ''
  const parsed = moment(value)
  if (!parsed.isValid()) return ''
  return parsed.format(BILLING_DATE_TIME)
}

/** Month and year for invoice list cells (e.g. July 2026). */
export const formatBillingMonthYear = (value?: string | null): string => {
  if (!value) return ''
  const parsed = moment(value)
  if (!parsed.isValid()) return ''
  return parsed.format('MMMM YYYY')
}

/** Same display format as formatBillingDateTime; preserves existing moment.utc usage. */
export const formatBillingDateTimeUtc = (value?: string | null): string => {
  if (!value) return ''
  const parsed = moment.utc(value)
  if (!parsed.isValid()) return ''
  return parsed.format(BILLING_DATE_TIME)
}
